import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React, { DetailedHTMLProps } from 'react';
import { useMediaQuery } from '@material-ui/core';

const useStyles = makeStyles<Theme, { gridTemplateColumns?: string }>((theme: Theme) =>
  createStyles({
    gridLayout: {
      display: 'grid',
      gridTemplateColumns: ({ gridTemplateColumns }) => gridTemplateColumns || '350px 1fr', // left: labels, right: fields
      columnGap: '16px',
      rowGap: '12px',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
      },
      // Tighter on paper: the row gap closes up, and the inputs give back the vertical padding
      // they need for a comfortable click target but not for reading. Targeted through MUI's
      // own global class names, which are stable, rather than this file's generated ones.
      '@media print': {
        rowGap: '3px',
        '& .MuiOutlinedInput-input': {
          paddingTop: 6,
          paddingBottom: 6,
        },
        '& .MuiOutlinedInput-multiline': {
          paddingTop: 6,
          paddingBottom: 6,
        },
        '& .MuiSelect-select': {
          paddingTop: 6,
          paddingBottom: 6,
        },
      },
    },
    mobileLayout: {
      display: 'grid',
      gap: '16px',
    },
  }),
);

export type FormGridProps = {
  gridTemplateColumns?: string;
} & DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export default function FormGrid(props: FormGridProps) {
  const { gridTemplateColumns, ...rest } = props;
  const classes = useStyles({ gridTemplateColumns });

  const isMobile = useMediaQuery('(max-width: 800px)');

  return <div className={isMobile ? classes.mobileLayout : classes.gridLayout} {...rest} />;
}
